'use client';
import { useUserStore } from '@/store/auth';
import axios from 'axios';

const useAxios = () => {
  const { tokens, setTokens, reset } = useUserStore();

  const axiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    timeout: 5000,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  let token =
    typeof window !== 'undefined' ? localStorage.getItem('auth-storage') : null;
  if (token && typeof token === 'string') {
    token = JSON.parse(token);
    token = token.state?.tokens?.access?.token;
  }

  axiosInstance.interceptors.request.use(
    async config => {
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    },
    error => {
      Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      if (error.response?.status === 401) {
        const refreshToken = tokens.refresh?.token;
        try {
          const { data } = await axiosInstance.post('auth/refresh-tokens', {
            refreshToken,
          });
          setTokens({ ...data });
          axiosInstance.defaults.headers.common['Authorization'] =
            `Bearer ${data.access.token}`;
          error.config.headers['Authorization'] = `Bearer ${data.access.token}`;
          return axiosInstance(error.config);
        } catch (err) {
          reset();
          return Promise.reject(err);
        }
      }
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export default useAxios;
